import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ArticleService} from '../../../../../services/article.service';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import Swal from 'sweetalert2';
import {BImage} from '../../../../../models/bimage.model';
import {environment} from '../../../../../environments/environment';
import {AuthService} from '../../../../../services/auth.service';
import {Router} from '@angular/router';

declare const $: any;

@Component({
  selector: 'app-photos',
  templateUrl: './photos.component.html',
  styleUrls: ['./photos.component.scss']
})
export class PhotosComponent implements OnInit {
  @ViewChild('closebutton') closebutton;
  images = [];
  imagesTmp = [];
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 15, 30, 50];
  search: any;
  perPage = 10;
  urlPhoto: any;
  url_photo: String;

  constructor(private articleService: ArticleService, private router: Router,
              private fb: FormBuilder, private authService: AuthService) {
  }

  ngOnInit(): void {
    this.authService.isAuthenticated().subscribe(isAuthenticated => {
      this.loadImages();
    }, error => {
      this.router.navigate(['/login']);
    });

    this.url_photo = environment.url_photo;
  }

  model = {
    name: '',
    path: ''
  };

  get f2() {
    return this.imageForm.controls;
  }

  imageForm = this.fb.group({
      //'name': ['', { validators: nameValidator('Le nom de l\'image', 2, 50), updateOn: 'change'}],
      'name': ['', Validators.required],
      'path': ['', [Validators.required]],
    }
  );

  loadImages() {
    this.articleService.getAllImages().subscribe(rs => {
      this.images = rs;
      this.imagesTmp = rs;
      // console.log("Liste des images");
      // console.log(rs);
    });
  }

  onSubmit() {
    if (this.imageForm.valid) {
      let image = new BImage();
      const imageInfo1: BImage = this.imageForm.value;
      image.name = this.model.name;
      image.path = this.urlPhoto;
      this.articleService.saveImage(image).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Image ajoutée avec succés',
          showConfirmButton: false,
          timer: 2500
        });
        this.loadImages();
        this.close();
        this.reloadComponent();
      }, error => {
       // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Erreur lors de l\'ajout de l\'image',
          showConfirmButton: false,
          timer: 1500
        });
      });
    } else {
      // Swal.fire({
      //   position: 'top-end',
      //   icon: 'error',
      //   title: 'Veuillez renseigner le nom et choisir une image.',
      //   showConfirmButton: false,
      //   timer: 3500
      // });
    }
  }

  //ça permet d'actualiser le composant
  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  close() {
    this.closebutton.nativeElement.click();
  }

  openFile() {
    $('#path').click();
  }

  whenClickForChangeImage: boolean = false;

  readFile(event: any) {
    this.whenClickForChangeImage = true;

    if (event.target.files && event.target.files[0]) {
      const file: File = event.target.files[0];
      // console.log("file :"+file);
      const reader = new FileReader();
      reader.onload = (readEvent: any) => {
        // console.log("url"+readEvent.target.result);
        this.urlPhoto = readEvent.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  msgphoto!: string;
  testPhoto = false;
  photo: string = "";

  selectFilePhoto(event: any) {
    //Angular 11, for stricter type
    let mimeType = event.target.files[0].type;
    // console.log("¤¤¤¤¤¤ Mimeeeeeeee")
    // console.log(mimeType);
    let sizeFile = event.target.files[0].size;
    if (!event.target.files[0] || event.target.files[0].length == 0) {
      this.msgphoto = 'Selectionner une photo';
    }
    // console.log("size!!!!!")
    // console.log(sizeFile)
    if (sizeFile < 2000000) {
      // console.log(mimeType);

      if (mimeType == "image/jpeg" || mimeType == "image/jpg" || mimeType == "image/png") {

        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msgphoto = "";
          this.testPhoto = true;
          // alert(this.test)
          this.urlPhoto = reader.result;
          this.testPhoto = this.urlPhoto;
          // console.log( this.urlPhotoBout)
        }
      } else {

        // this.msg = "Ce type de fichier n'est pas pris en compte.";
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msgphoto = "Ce type de fichier n'est pas pris en compte.";
          this.urlPhoto = reader.result;
          this.testPhoto = false;
        }
      }
    } else {
      // this.msg = "la taille de l'image est trop grande";
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.msgphoto = "La taille de l'image est trop grande";
        this.urlPhoto = reader.result;
        this.photo = this.urlPhoto;
        this.testPhoto = false;
        // console.log( this.urlPhotoBout)
      }
    }
  }

  updatedPhoto: BImage;
  oldPath: string;

  EditPhoto(img: BImage) {
    this.updatedPhoto = img;
    this.oldPath = img.path;
    // console.log("~~~~~~~~~~~~~~~")
    // console.log(img)
    // console.log("~~~~~~~~~~~~~~~")
    this.imageForm = this.fb.group({
      name: new FormControl(img.name, Validators.required),
      path: new FormControl(''),
    })
  }

  onSubmitEditForm() {
    // console.log(this.imageForm.valid)
    //console.log(this.urlPhoto);
    if (this.imageForm.valid) {
      const imageInfo1: BImage = this.imageForm.value;
      this.updatedPhoto.name = imageInfo1.name;
      this.whenClickForChangeImage == false ? this.updatedPhoto.path = this.oldPath : this.updatedPhoto.path = this.urlPhoto;
      this.articleService.updateImage(this.updatedPhoto).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Image modifiée avec succés',
          showConfirmButton: false,
          timer: 2500
        });
        this.loadImages();
        this.close();
      }, error => {
        // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Erreur lors de la modification de l\'image',
          showConfirmButton: false,
          timer: 1500
        });
      });
    } else {
      // Swal.fire({
      //   position: 'top-end',
      //   icon: 'error',
      //   title: 'Veuillez renseigner le nom et choisir une image.',
      //   showConfirmButton: false,
      //   timer: 3500
      // });
    }
  }

  deletePhoto(img: BImage) {
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer cette image ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.articleService.deletePhoto(img.id).subscribe(
          rs => {

            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Image supprimée avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadImages();
          }, error => {
            // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Erreur lors de la suppression de l\'image',
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })
  }

  copierLien(c: any, lienElement: any) {
    const range = document.createRange();
    range.selectNode(lienElement);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
    navigator.clipboard.readText().then((copiedText) => {
      alert('Le lien a été copié : ' + copiedText);
      // console.log('Le lien copié : ', copiedText);
    }).catch((error) => {
      // console.error('Erreur lors de la lecture du texte copié : ', error);
    });
  }


  clearForm() {
    this.imageForm.reset();
  }
}
